export default __webpack_public_path__ + "static/media/flex.2c5b4c29.png";